import BookIndex from "components/shared/book/list";
import { Transition } from "components/shared/column";
import SharedReactTable from "components/shared/reactTable";
import { dateTimeToView } from "helpers/date";
import { DateRangeColumnFilter, DebouncedRangeColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";

class AdminInsolvencyRegistry extends BookIndex {
    componentWillUnmount() {
        this.props.clearParams();
    }

    get tableColumns() {
        return [
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
            },
            {
                Header: "Список отметивших организаций",
                accessor: "organizationNames",
                sortable: false,
                filterable: false,
                Cell: ({ value }) => value.map((item, i) => <div key={i}>{item}</div>),
            },
            {
                Header: "Ранг",
                accessor: "insolvencyRank",
                filterable: true,
                filterType: "numberRange",
                Filter: DebouncedRangeColumnFilter,
            },
            { Header: "ИНН", accessor: "inn", filterable: true },
            { Header: "КПП", accessor: "kpp", filterable: true },
            {
                Header: "Комментарии",
                accessor: "comments",
                sortable: false,
                filterable: false,
                Cell: ({ value }) => (
                    <ol className="pl-3 mb-0">
                        {value.map((item, i) => (
                            <li key={i}>{item}</li>
                        ))}
                    </ol>
                ),
            },
            {
                Header: "Дата создания",
                accessor: "createdAt",
                filterable: true,
                Filter: DateRangeColumnFilter,
                filterType: "dateTimeRange",
                Cell: ({ value }) =>
                    this.props?.organizationTimezone?.id
                        ? new Date(value).toLocaleString("ru-RU", { timeZone: this.props?.organizationTimezone.id })
                        : dateTimeToView(value),
                CSVExport: ({ value }) =>
                    this.props?.organizationTimezone?.id
                        ? new Date(value).toLocaleString("ru-RU", { timeZone: this.props?.organizationTimezone.id })
                        : dateTimeToView(value),
            },
            {
                Header: "Дата обновления",
                accessor: "updatedAt",
                filterable: true,
                Filter: DateRangeColumnFilter,
                filterType: "dateTimeRange",
                Cell: ({ value }) =>
                    this.props?.organizationTimezone?.id
                        ? new Date(value).toLocaleString("ru-RU", { timeZone: this.props?.organizationTimezone.id })
                        : dateTimeToView(value),
                CSVExport: ({ value }) =>
                    this.props?.organizationTimezone?.id
                        ? new Date(value).toLocaleString("ru-RU", { timeZone: this.props?.organizationTimezone.id })
                        : dateTimeToView(value),
            },
        ];
    }

    renderHead = () => {
        return (
            <div className="book-list__head">
                <div className="book-list__head-close close close--sm" onClick={this.close} />
                <div className="book-list__head-title">Реестр надежности контрагентов CARGO.RUN</div>
                <div className="btn-toolbar" />
            </div>
        );
    };

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;

    render() {
        return (
            <div className="page-content">
                <Transition dir="full">
                    <div className="page-book__list book-list list book-list--nofilter">
                        {this.renderHead()}
                        {this.renderListComponent()}
                    </div>
                </Transition>
            </div>
        );
    }
}

export default tableContainer(AdminInsolvencyRegistry, "admin-insolvency-registry");
